import axiosInstance from "../../utils/config/config";

export const getAllNotifications = () => async (dispatch) => {
  try {
    dispatch({
      type: "notificationsRequest",
    });
    const { data } = await axiosInstance.get(`/notifications/getAll`);
    dispatch({
      type: "notificationsSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "notificationsFailure",
      payload: error,
    });
  }
};
